import React from 'react';
import HeaderLogged from './components/header_logged';
import { API_URL } from './config'

function ManagerPage() {
    return (
        <> 
            <HeaderLogged />
            
        </>
    );
  }
  
  export default ManagerPage; 